import React from "react";
import { Wrapper } from "../style";
import { Dropdown } from "antd";
import { FiLogOut } from "react-icons/fi";
import img from "../../../assets/images/Group 1000003666.png";
import { clearToken } from "../../../redux/modules/auth/actions";
import { useDispatch } from "react-redux";

const Options = () => {
  const dispatch = useDispatch();
  const handleLogout = () => {
    dispatch(clearToken());
  };

  const menuItems = [
    {
      key: "1",
      label: (
        <button
          onClick={handleLogout}
          style={{
            margin: "0",
            display: "flex",
            gap: "10px",
            alignItems: "center",
            color: "red",
            borderRadius: "10px",
            fontWeight: 400,
            fontSize: "15px",
            paddingRight: "25px",
            border: "none",
            outline: "none",
            cursor: "pointer",
          }}
        >
          <div
            style={{
              width: "35px",
              height: "35px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              color: "red",
            }}
          >
            <FiLogOut size={20} />
          </div>
          Logout
        </button>
      ),
    },
  ];
  const menu = {
    items: menuItems,
  };
  return (
    <>
      <Wrapper>
        <div className="text">
          <h2>Abduvahabov I</h2>
          <p>Admin</p>
        </div>
        <Dropdown menu={menu}>
          <button className="img" onClick={(e) => e.preventDefault()}>
            <img src={img} alt="" />
          </button>
        </Dropdown>
      </Wrapper>
    </>
  );
};

export default Options;
